import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerIntegralExchangeSettingListDataApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeSetting/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppConsumerIntegralExchangeSettingExportDataApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeSetting/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppConsumerIntegralExchangeSettingApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeSetting/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppConsumerIntegralExchangeSettingApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeSetting/init",
    method: "post",
    data
  });
}

// 根据条件获取条数
export function findAppConsumerIntegralExchangeSettingCountByConditionApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeSetting/findCountByCondition",
    method: "post",
    data
  });
}